import permissionCheck from '@/util/ACL/permissionCheck';
import store from '@/store.js'
import roleCheck from '@/util/ACL/permissionCheck';
import permissions from '@/util/ACL/permissionMap';
import modelPermissionCheck from '@/util/ACL/modelPermissionCheck';

function isProjectEditPermission(permission) {
  const editPermissions = [permissions.PROJECT_EDIT, permissions.PROJECT_EDIT_OWN];
  const requested = Array.isArray(permission) ? permission : [permission];
  return requested.length > 0 && requested.every(item => editPermissions.includes(item));
}

export default  {
  name: 'isGrantedModel',
  methods: {
    isGranted(permission, model){
      let hasPermission = false;
      let user = store.state.user;

      if (user.isAdmin) {
        hasPermission = true;
      } else if (model && model.engagement_permissions && isProjectEditPermission(permission)) {
        // Engagements can only be edited by their own team, whatever the user's client permissions
        hasPermission = !!model.engagement_permissions.edit;
      } else {
        if (permission) {

          hasPermission = modelPermissionCheck(permission, model)
        }
        // Check permissions on client
        if (!hasPermission && permissionCheck(permission)){
          hasPermission = true;
          return true;
        }
      }

      return hasPermission;
    }
  }
}
